/*global $, document, window, setTimeout, alert, FG */
(function () {
    "use strict";

    /**
     * FrontGate JS database class to persist data on the frontend
     * @returns {FG.DB}
     * @constructor
     * @depends lawnchair-0.6.1.min.js
     * @since 9/17/2013
     */
    FG.Job = function () {
        return this;
    };

    FG.Job.prototype = {

        /**
         * @constructor
         */
        constructor: FG.Job(),

        /**
         * Poll the server every second
         */
        startPolling: function () {

            var interval = setInterval(

                //Poll every second.
                function(){

                    var Ajax = new FG.Ajax('job/check');

                    Ajax.setMessageDiv('#div-message');

                    Ajax.setSuccessCallback(function(FGResponse){

                        if(FGResponse.data.jobStatus == 4){

                            $("#div-waiting-message").html('We finished processing your request, please proceed to the cart, or checkout.');

                            clearInterval(interval);
                        }

                        //If we have data, then show it inline.
                        if(FGResponse.data.modal){
                            $('#div-modal').hide().html(FGResponse.data.modal).slideDown('slow');

                            //Ensure that a cart timer has all the data it needs, and turn it on.
                            FG.Event.activateCartTimer(FGResponse);
                        }

                        //If we have a location, redirect them
                        if(FGResponse.data.location){

                            FG.CartTimer.pauseTimer();

                            window.location.href = FGResponse.data.location;
                        }
                    });

                    Ajax.setFailureCallback(function(FGResponse){

                        $("#div-waiting-message").hide();

                        $(this).html(FGResponse.msg);

                        clearInterval(interval);

                    });

                    Ajax.send();

                }, 1000
            );
        }
    };
}());
